import {
  NOTIFICATION_CONSENT_DISCLOSURE_HASH,
  NotificationConsentPayload,
  NotificationConsentSource,
} from "@greenflagdate/shared";

// Consent to the disclosure this client renders, captured on `source`. The
// server rejects it unless the hash matches its own canonical disclosure.
//
// Sent on its own (no notification_preferences), this is the "text me about
// everything" opt-in: the server decides which categories that covers, so the
// text-eligibility policy never has to be mirrored in the client.
export const textOptInConsent = (
  source: NotificationConsentSource
): NotificationConsentPayload => ({
  hash: NOTIFICATION_CONSENT_DISCLOSURE_HASH,
  source,
});
